/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineId200,
  GetApiV1ClassroomdisciplineId401,
  GetApiV1ClassroomdisciplineId404,
  GetApiV1ClassroomdisciplineId500,
  GetApiV1ClassroomdisciplineIdPathParams,
  GetApiV1ClassroomdisciplineIdQueryResponse,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineId.ts";
import { classroomDisciplineDetailViewModelSchema } from "../classroomDisciplineDetailViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineId200Schema = z.lazy(
  () => classroomDisciplineDetailViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineId401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineId404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineId500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineId500>;

export const getApiV1ClassroomdisciplineIdQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineId200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdQueryResponse>;
